import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
export const refreshSession = async () => {
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  try { await refreshing; return true; } catch { return false; }
};

api.interceptors.response.use((r) => r, async (error) => {
  const cfg = error.config || {};
  const skip = /\/auth\/(login|register|refresh|logout)/.test(cfg.url || "");
  if (error.response?.status === 401 && !cfg._retry && !skip) {
    cfg._retry = true;
    if (await refreshSession()) return api(cfg);
  }
  return Promise.reject(error);
});

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function streamMessage(conversationId, body, onEvent, signal) {
  const go = () => fetch(`${API}/conversations/${conversationId}/messages`, {
    method: "POST", credentials: "include", signal,
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  let res = await go();
  if (res.status === 401 && (await refreshSession())) res = await go();
  if (!res.ok) {
    let detail = null;
    try { detail = (await res.json()).detail; } catch { /* non-json */ }
    throw new Error(typeof detail === "string" ? detail : `Request failed (${res.status})`);
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const line = buf.slice(0, i).split("\n").find((l) => l.startsWith("data: "));
      buf = buf.slice(i + 2);
      if (line) onEvent(JSON.parse(line.slice(6)));
    }
  }
}

export const fmtTime = (iso) => iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "";
